import React, { Component } from "react";
import { connect } from 'react-redux';
import { Form } from "react-bootstrap";
import { UPDATE_STATUS } from '../../../../../../../../actions/sceneActions'
import { toast } from 'react-toastify';
class EnableStudio extends Component {
    state = {
        enableStudio: this.props.enableStudio
    }
    componentWillReceiveProps(nextProps) {
        const { enableStudio } = nextProps;
        this.setState({ enableStudio: enableStudio })
    }
    onUpdateStatus = event => {
        const { enableStudio } = this.state;
        const { wallID, scene } = this.props;
        const totalTime  = scene.scenes.filter(obj=> obj['totalTime']>0 && obj['status']==1)

            if((!totalTime.length) && !enableStudio){
                const totalSence = scene.scenes.filter(obj=> obj['status']==1)
                toast.error(`${!totalSence.length ? 'At least 1 Enable Scene with more than 00:00:00 time required to keep enable studio.' : 'Need an active scene longer than 00:00:00 to keep the studio enabled.' }`, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return false
            }
 
        this.setState({ enableStudio: !enableStudio }, () => this.props.UPDATE_STATUS(!enableStudio, wallID))
    }

    render() {

        const { enableStudio } = this.state;

        return <>

            <Form.Check checked={enableStudio} onClick={this.onUpdateStatus} label="" className="ms-1 enable-studio p-0" type="switch" id="enable-studio" />

        </>
    }

}


const mapStateToProps = state => {  
    return {
        scene : state.scene    
    }
}
const mapDispatchToProps = dispatch => {
    return {
        UPDATE_STATUS: (status, wallId) => dispatch(UPDATE_STATUS(status, wallId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EnableStudio);